[
	{
		"text": "home",
		"to": "/",
		"color": "blue",
		"font": "serif"
	},
	{
		"text": "photos",
		"to": "/photography",
		"color": "lpink",
		"font": "sans-serif"
	},
	{
		"text": "published works",
		"to": "/publications",
		"color": "thelink",
		"font": "blog",
		"disabled": true
	},
	{
		"text": "music",
		"to": "/music",
		"color": "pink",
		"font": "monospaced",
		"disabled": true
	},
	{
		"text": "projects",
		"to": "/projects",
		"color": "purpre",
		"font": "bit"
	}
]